export default __webpack_public_path__ + "static/concept_back-f5b15481f858f970cf073f9f5c04746a.webp";